export const iconFontAwesomeHolidaysChampagneGlasses = (
	<i className="fa-solid fa-champagne-glasses"></i>
);
